module.exports = __webpack_public_path__ + "static/media/cleanwater.ebd4e1df.jpg";